import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const mode = params.get("mode") === "activate" ? "activate" : "reset";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) return toast.error("Password minimal 6 karakter");
    if (password !== confirm) return toast.error("Konfirmasi password tidak cocok");
    if (!token) return toast.error("Token tidak ada di URL");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success(mode === "activate" ? "Akun berhasil diaktifkan! Silakan login." : "Password berhasil direset! Silakan login.");
      setTimeout(() => nav("/login", { replace: true }), 900);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Gagal memproses");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[#f7f9f7] p-4">
      <div className="w-full max-w-md imsyaf-card p-8">
        <div className="text-xs uppercase tracking-widest text-slate-400">IMSYAF</div>
        <h1 className="font-display text-2xl font-bold text-[#064E3B] mt-1">
          {mode === "activate" ? "Aktivasi Akun" : "Reset Password"}
        </h1>
        <p className="text-sm text-slate-500 mt-1">
          {mode === "activate"
            ? "Selamat datang! Silakan buat password Anda untuk mengaktifkan akun."
            : "Buat password baru untuk akun Anda."}
        </p>

        <form onSubmit={submit} className="mt-6 space-y-3">
          <div>
            <label className="text-xs">Password Baru</label>
            <input type="password" className="imsyaf-input" value={password}
              onChange={(e) => setPassword(e.target.value)} minLength={6} required
              data-testid="reset-password-input" />
          </div>
          <div>
            <label className="text-xs">Ulangi Password</label>
            <input type="password" className="imsyaf-input" value={confirm}
              onChange={(e) => setConfirm(e.target.value)} minLength={6} required
              data-testid="reset-password-confirm" />
          </div>
          <button type="submit" disabled={loading}
            className="imsyaf-btn-primary w-full justify-center disabled:opacity-60"
            data-testid="reset-submit-btn">
            {loading ? "Memproses..." : (mode === "activate" ? "Aktifkan Akun" : "Simpan Password Baru")}
          </button>
        </form>
      </div>
    </div>
  );
}
